module.exports = __webpack_public_path__ + "img/[晕].8a5b9c23.svg";